import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4","key":"svg-0"}]]

const IconCornerRightUp = createReactComponent('outline', 'corner-right-up', 'CornerRightUp', __iconNode);

export default IconCornerRightUp;